exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-settings[data-v-459af006]{padding:8px 14px}.message-settings-options label[data-v-459af006]{display:block}", ""]);

// exports
